<template>
  <div v-if="user" class="logged-user flex flex-row items-center">
    <icon-in-circle width="35px" height="35px" class="db mh2 mv3">
      <font-awesome-icon :icon="['fa', 'user']" class="entity-icon"/>
    </icon-in-circle>
    <div class="flex flex-column f6 mr1">
      <span class="db text-line-1 ma1" id="user_full_name" :title="user.fullName" style="color: #BCCCDC;">{{ user.fullName }}</span>
      <span class="db mt1 text-line-1 ma1" id="user_company_title" :title="user.companyTitle" style="color: #9FB3C8;">{{ user.companyTitle }}</span>
    </div>
  </div>
</template>

<script>
import IconInCircle from '@/components/ui/IconInCircle.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    IconInCircle
  },
  computed: {
    ...mapGetters('user', ['user'])
  }
}
</script>

<style lang="scss" scoped>
.logged-user {
  border-color: #486581;
  border-top-style: solid;
  border-top-width: 1px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
</style>
